import React from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import withHandlers from 'recompose/withHandlers';
import get from 'lodash.get';
import ExtraUserInformationFormModal from './ExtraUserInformationFormModal';
import styles from './SecondaryEmailExtraInformation.css';
import Input from '../Forms/Input';
import { STUDENT_VIEW } from '../../redux/app';
import required from '../../utils/fieldRequired';
import emailMaxLen from '../../utils/emailMaxLen';
import { markAsSeenAction } from '../../redux/notifications';
import NOTIFICATIONS from '../../../constants/notifications';

const SecondaryEmailExtraInformation = ({ ...props }) => (<ExtraUserInformationFormModal
    title="Secondary Email Address"
    subtitle="Add your personal email address to this account so that you don’t lose access after you graduate. You can do this later from your Account Settings."
    saveButton="Save Email"
    className={styles.container}
    closeButton="Skip for now"
    {...props}
>
    <Field
        className={styles.field}
        name="secondaryEmail"
        id="secondaryEmailExtraInfo"
        label="Secondary Email"
        component={Input}
        validate={[required, emailMaxLen]}
    />
</ExtraUserInformationFormModal>);

export default compose(
    connect(({ me, app, auth, notifications }) => ({
        show: (me &&
            !me.secondaryEmail &&
            app.view === STUDENT_VIEW &&
            Number(auth.level) === 5) && !notifications[NOTIFICATIONS.SECONDARY_EMAIL],
        initialValues: {
            secondaryEmail: get(me, 'secondaryEmail'),
        },
    }), {
        markAsSeen: markAsSeenAction,
    }),
    withHandlers({
        onClose: props => () => {
            props.markAsSeen(NOTIFICATIONS.SECONDARY_EMAIL);
        },
    }),
    branch(
        ({ show }) => !show,
        renderNothing,
    ),
)(SecondaryEmailExtraInformation);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/SecondaryEmailExtraInformation.js